module.exports = __webpack_public_path__ + "img/logo.424da68c.png";